var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "900"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" Adicionar Usuário(s) ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Buscar usuário",
      "prepend-inner-icon": "mdi-magnify",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "placeholder": "Digite o nome ou CPF do usuário"
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.usuarios,
      "items-per-page": 10,
      "search": _vm.search,
      "footer-props": _vm.$footerProps,
      "show-select": "",
      "item-key": "usuarioId"
    },
    scopedSlots: _vm._u([{
      key: `item.cpf`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$esconderCpf(item.cpf)) + " ")];
      }
    }, {
      key: "top",
      fn: function () {
        return [_c('div', {
          staticClass: "pa-2 d-flex align-center"
        }, [_c('v-checkbox', {
          staticClass: "mt-0",
          attrs: {
            "label": "Selecionar todos os usuários da página",
            "hide-details": ""
          },
          on: {
            "change": _vm.toggleSelecionarTodos
          },
          model: {
            value: _vm.selecionarTodos,
            callback: function ($$v) {
              _vm.selecionarTodos = $$v;
            },
            expression: "selecionarTodos"
          }
        })], 1)];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.usuariosSelecionados,
      callback: function ($$v) {
        _vm.usuariosSelecionados = $$v;
      },
      expression: "usuariosSelecionados"
    }
  })], 1)], 1)], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": "Adicionar Selecionados"
    },
    on: {
      "click": function ($event) {
        return _vm.adicionarUsuarios();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }